import Link from 'next/link'
import LinkArrow from '../icons/LinkArrow'

interface Props extends React.HTMLAttributes<HTMLAnchorElement> {
  href?: string
  text: string
  hideArrow?: boolean
}

const CustomLink = ({
  href,
  className,
  text,
  hideArrow,
  ...props
}: Props): JSX.Element => {
  return href ? (
    <Link
      href={href}
      target={href.startsWith('http') ? '_blank' : '_self'}
      rel={href.startsWith('http') ? 'noreferrer' : ''}
      className={`${hideArrow ? '' : 'block'} w-fit-content ${className || ''}`}
      {...props}
    >
      <InnerCustomLink hideArrow={hideArrow} text={text} />
    </Link>
  ) : (
    <InnerCustomLink
      hideArrow={hideArrow}
      className={className}
      text={text}
      {...props}
    />
  )
}

export default CustomLink

const InnerCustomLink = ({ text, className, hideArrow }: Props) => {
  return (
    <span
      className={`font-demibold ${
        hideArrow ? '' : 'grid grid-cols-[repeat(2,auto)]'
      } items-center space-x-2 w-fit-content text-blue transition-colors hover:text-blue-110 focus:text-blue-110 sm:space-x-3 ${
        className || ''
      }`}
    >
      <span>{text}</span>
      {!hideArrow && (
        <LinkArrow className='h-2.5 w-auto stroke-current sm:h-3.5' />
      )}
    </span>
  )
}
